// biome-ignore lint/style/noRestrictedImports: the one place the package is configured
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge configured for our theme. Use this, not the package's own
 * `twMerge`, which doesn't know `text-xxs` and treats it as a text colour:
 * `twMerge('text-xxs text-gray-400')` drops the size.
 */
export const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: ['xxs'] }] } },
});
